import React from "react";
import Wrapper from "./components/wrapper/Wrapper";
import "antd/dist/antd.css";

function App() {
  return <Wrapper />;
}

export default App;
